import { Select, Spin } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { posService } from '@/services/pos.service';
import type { PosLiveSession, CommissionStaff } from '../types';

interface Props {
  storeId?: string;
  value?: string;
  onChange: (sessionId: string, commissionStaff: CommissionStaff[]) => void;
}

function buildCommissionStaff(session: PosLiveSession): CommissionStaff[] {
  const staff: CommissionStaff[] = [];
  if (session.streamer_staff_id) {
    staff.push({ role_code: 'STREAMER', staff_id: session.streamer_staff_id._id });
  }
  if (Array.isArray(session.sale_ib_staff_ids)) {
    session.sale_ib_staff_ids.forEach((s) => {
      staff.push({ role_code: 'SALE_IB', staff_id: s._id });
    });
  }
  if (Array.isArray(session.assistant_staff_ids)) {
    session.assistant_staff_ids.forEach((s) => {
      staff.push({ role_code: 'PHU_LIVE', staff_id: s._id });
    });
  }
  return staff;
}

export function LiveSessionPicker({ storeId, value, onChange }: Props) {
  const { data: sessions = [], isLoading } = useQuery({
    queryKey: ['pos', 'live-sessions', storeId],
    queryFn: () => posService.getLiveSessions(),
    enabled: !!storeId,
  });

  const handleChange = (sessionId: string) => {
    const session = sessions.find((s) => s._id === sessionId);
    if (session) {
      onChange(sessionId, buildCommissionStaff(session));
    }
  };

  return (
    <Select
      placeholder={storeId ? 'Chọn phiên Livestream' : 'Chọn chi nhánh trước'}
      disabled={!storeId}
      loading={isLoading}
      value={value}
      onChange={handleChange}
      style={{ width: '100%' }}
      notFoundContent={isLoading ? <Spin size="small" /> : 'Không có phiên đang hoạt động'}
      options={sessions.map((s) => ({
        value: s._id,
        label: s.title || `Phiên ${new Date(s.started_at).toLocaleTimeString('vi-VN')}`,
      }))}
    />
  );
}
